export const LAYER_INDEXES = Object.seal({
  main: 1,
  overlay: 2,
  text: 3,
  audio: 4,
} as const);

export type LayerName = keyof typeof LAYER_INDEXES;
export type LayerIndex = (typeof LAYER_INDEXES)[LayerName];

export const NEW_LAYER_INDEXES = Object.seal({
  main: 0,
  overlay: 1,
  text: 2,
  audio: -1,
} as const);

export type NewLayerName = keyof typeof NEW_LAYER_INDEXES;
export type NewLayerIndex = (typeof NEW_LAYER_INDEXES)[NewLayerName];
